module.exports = __webpack_public_path__ + "img/07.bd50a69.png";